import Icon from '../components/Icon.vue'

Icon.register({"video-camera":{"width":1792,"height":1792,"paths":[{"d":"M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/video-camera.js
// module id = 1228
// module chunks = 0